import { makeCustomerCardsRepository } from 'modules/customer/infra/repositories';

import { FetchCustomerCardsUseCase } from './implementations/FetchCustomerCardsUseCase';

let instance: FetchCustomerCardsUseCase | null = null;

export default function makeFetchCustomerCardsUseCase() {
  if (!instance) {
    const repository = makeCustomerCardsRepository();

    instance = new FetchCustomerCardsUseCase(repository);
  }

  return instance;
}
